<template>
    <header class="header-global">
      <nav class="navbar">
        <div class="container">
          <!-- <div> -->
            <base-switch :value="this.$i18n.locale === 'jp'" @onswitch="handleLanguageSwitch"></base-switch>
          <!-- </div> -->
        </div>
      </nav>
    </header>
</template>


<script>
export default {
  data () {
    const languages = {
      langs: [
      {
        language: '日本語',
        code: 'jp'
      },
      {
        language: 'English',
        code: 'en'
      }]
    };
    return languages
  },
  methods: {
    handleLanguageSwitch(isEnglish) {
      if (!isEnglish) {
        this.$i18n.locale = 'en'
      }
      else {
        this.$i18n.locale = 'jp'
      }
    }
  }
};
</script>


<style>
.navbar .container {
  display: flex;
}

base-switch {
  background-color: grey;
  border-color: grey;
}

@media screen and (max-width: 677px) {
  .nav-main {
    display: none;
  }
}
@media screen and (min-width: 678px) {
  .responsive-hide {
    display: none;
  }
}
</style>
